/**
 * App.js
 */
import splitText from '../libs/splitText';
import PageJudge from '../libs/PageJudge';
import setSmoothScroll from './setSmoothScroll';
import setHeight from './setHeight';
import setLoading from './setLoading';
import setDrawerButton from './setDrawerButton';
import setPostSlider from './setPostSlider';
import setOtherSlider from './setOtherSlider';
import setInterviewSlider from './setInterviewSlider';
import setAcdnToggle from './setAcdnToggle';
import setOneScroll from './setOneScroll';
import setScrollTrigger from './setScrollTrigger';
import setCategorySort from './setCategorySort';
import setModal from './setModal';
import setDataCounter from './setDataCounter';
import setScrollHint from './setScrollHint';

// libs
window.PageJudge = new PageJudge();

// LODDING
window.LODDING = true;

/**
 * @name App
 * @description アプリケーション全体の設定
 */
class App {
	constructor() {
		this.html = document.querySelector('html');
		splitText();
	}

	/**
	 * @name __init
	 * @description レンダリング
	 */
	async __init() {
		new setSmoothScroll();
		new setHeight();
		new setLoading();
		new setDrawerButton();
		new setPostSlider();
		new setInterviewSlider();
		new setAcdnToggle();
		new setScrollTrigger();
		new setScrollHint();
		new setOtherSlider();

		window.PageJudge.__judge('top') && new setOneScroll();
		window.PageJudge.__judge('top') && new setDataCounter();
		window.PageJudge.__judge('job') && new setCategorySort();
		window.PageJudge.__judge('job') && new setModal();

		if(window.PageJudge.__judge('top')) {
			let closeButtons = document.querySelector('.t-hero__news .close-button');
			let openButtons = document.querySelector('.t-hero__news .open-button');

			closeButtons.addEventListener('click', () => {
				console.log('close');
				document.querySelector('.t-hero__news').classList.add('is-close');
			});

			openButtons.addEventListener('click', () => {
				console.log('open');
				document.querySelector('.t-hero__news').classList.remove('is-close');
			});
		}
	}
}

export default App;
